import { Injectable, inject } from "@angular/core";
import { CanActivateFn, Router, UrlTree } from "@angular/router";
import { OrganizationService } from "../epicare-public/administration/domain/services/organization.service";

@Injectable({
  providedIn: "root",
})
export class OrganizationDetailsGuardService {
  constructor(
    private organizationService: OrganizationService,
    private router: Router
  ) {}

  /**
   * Determines whether an organization's details page can be activated.
   * @return True if the user's role allows opening an organization's details, or a UrlTree redirecting to /landing otherwise
   */
  canActivate(): boolean | UrlTree {
    if (this.organizationService.canGetOrganizationDetailsById()) {
      return true;
    } else {
      return this.router.createUrlTree(["/landing"]);
    }
  }
}

export const OrganizationDetailsGuard: CanActivateFn = (): boolean | UrlTree => {
  return inject(OrganizationDetailsGuardService).canActivate();
};
